require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-team-بولينا-غارسون.json") })
        }
      }, "path---ar-eg-team-بولينا-غارسون");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-team-بولينا-غارسون!./.cache/json/ar-eg-team-بولينا-غارسون.json
// module id = 456
// module chunks = 231608221292675